// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

const GRID_STYLES = {
  VERTICAL: {
    value: 'Vertical',
    get label() {
      return localizer.getText('REPORT_PART_GRID_CONSTANTS_LABEL_VERTICAL');
    },
    className: 'vertical'
  },
  HORIZONTAL: {
    value: 'Horizontal',
    get label() {
      return localizer.getText('REPORT_PART_GRID_CONSTANTS_LABEL_HORIZONTAL');
    },
    className: 'horizontal'
  },
  PIVOT: {
    value: 'Pivot',
    get label() {
      return localizer.getText('REPORT_PART_GRID_CONSTANTS_LABEL_PIVOT');
    },
    className: 'pivot'
  },
  DRILL_DOWN: {
    value: 'Drilldown',
    get label() {
      return localizer.getText('REPORT_PART_GRID_CONSTANTS_LABEL_DRILL_DOWN');
    },
    className: 'drill-down'
  }
};
const ALTERNATIVE_BACKGROUND = {
  NONE: {
    value: 'None',
    get label() {
      return localizer.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_NONE');
    }
  },
  COLUMNS: {
    value: 'Columns',
    get label() {
      return localizer.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_COLUMNS');
    }
  },
  ROWS: {
    value: 'Rows',
    get label() {
      return localizer.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_ROWS');
    }
  },
  COLUMNS_AND_ROWS: {
    value: 'Column and Rows',
    get label() {
      return localizer.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_COLUMNS_AND_ROWS');
    }
  }
};
const CONTAINER_NAME = {
  COLUMNS: 'columns',
  ROWS: 'rows',
  SEPARATORS: 'separators',
  VALUES: 'values'
};
const FREEZE_HEADERS = {
  VERTICALLY: {
    value: 'vertically',
    get label() {
      return localizer.getText('REPORT_PART_GRID_CONSTANTS_LABEL_VERTICALLY');
    }
  },
  HORIZONTALLY: {
    value: 'horizontally',
    get label() {
      return localizer.getText('REPORT_PART_GRID_CONSTANTS_LABEL_HORIZONTALLY');
    }
  }
};

export default {
  FIELD_PROPERTY_CONFIG: {
    Vertical: {
      separators: {
        hideSubTotal: true,
        hideAllHeaderFormating: true
      }
    },
    Horizontal: {
      separators: {
        hideSubTotal: true,
        hideAllHeaderFormating: true
      }
    },
    Pivot: {
      columns: {
        hideSubTotal: true,
        hideConflitHeaderFormating: true
      },
      separators: {
        hideSubTotal: true,
        hideAllHeaderFormating: true
      },
      values: {
        hideColumnGroup: true
      }
    },
    Drilldown: {
      rows: {
        hideSubTotal: true
      },
      separators: {
        hideSubTotal: true,
        hideAllHeaderFormating: true
      }
    }
  },
  NUMBER_OF_PREVIEW_SEPARATOR: 2,
  GRID_STYLES,
  ALTERNATIVE_BACKGROUND,
  FREEZE_HEADERS,
  CONTAINER_NAME,
  MAX_ROW: 50,
  SEPARATOR_STYLE: {
    COMMA: {
      value: 'Comma',
      get label() {
        return localizer.getText('REPORT_PART_GRID_CONSTANTS_LABEL_COMMA');
      },
      className: 'comma',
      multiLevel: false,
      withLabel: false,
      multiLine: false
    },
    COMMA_WITH_LABEL: {
      value: 'CommaWithLabel',
      get label() {
        return localizer.getText('REPORT_PART_GRID_CONSTANTS_LABEL_COMMA_WITH_LABEL');
      },
      className: 'comma-label',
      multiLevel: false,
      withLabel: true,
      multiLine: false
    },
    LINE: {
      value: 'Line',
      get label() {
        return localizer.getText('REPORT_PART_GRID_CONSTANTS_LABEL_LINE');
      },
      className: 'line',
      multiLevel: false,
      withLabel: false,
      multiLine: true
    },
    LINE_WITH_LABEL: {
      value: 'LineWithLabel',
      get label() {
        return localizer.getText('REPORT_PART_GRID_CONSTANTS_LABEL_LINE_WITH_LABEL');
      },
      className: 'line-label',
      multiLevel: false,
      withLabel: true,
      multiLine: true
    },
    MULTI_LEVEL: {
      value: 'MultiLevel',
      get label() {
        return localizer.getText('REPORT_PART_GRID_CONSTANTS_LABEL_MULTI_LEVEL');
      },
      className: 'multi-level',
      multiLevel: true,
      withLabel: false,
      multiLine: false
    },
    MULTI_LEVEL_WITH_LABEL: {
      value: 'MultiLevelWithLabel',
      get label() {
        return localizer.getText('REPORT_PART_GRID_CONSTANTS_LABEL_MULTI_LEVEL_WITH_LABEL');
      },
      className: 'multi-level-label',
      multiLevel: true,
      withLabel: true,
      multiLine: false
    },
    LOGICAL: {
      value: 'Logical',
      get label() {
        return localizer.getText('REPORT_PART_GRID_CONSTANTS_LABEL_LOGICAL');
      },
      className: 'logical',
      multiLevel: false,
      withLabel: false,
      multiLine: false
    }
  },
  MAPPING_GRID_STYLE: [
    {
      fromStyle: GRID_STYLES.VERTICAL.value,
      toStyle: GRID_STYLES.HORIZONTAL.value,
      mappings: [
        {
          fromContainer: [CONTAINER_NAME.COLUMNS],
          toContainer: CONTAINER_NAME.ROWS
        }
      ]
    },
    {
      fromStyle: GRID_STYLES.VERTICAL.value,
      toStyle: GRID_STYLES.DRILL_DOWN.value,
      mappings: [
        {
          fromContainer: [CONTAINER_NAME.COLUMNS],
          toContainer: CONTAINER_NAME.ROWS
        },
        {
          fromContainer: [CONTAINER_NAME.SEPARATORS],
          toContainer: CONTAINER_NAME.SEPARATORS
        }
      ]
    },
    {
      fromStyle: GRID_STYLES.VERTICAL.value,
      toStyle: GRID_STYLES.PIVOT.value,
      mappings: [
        {
          fromContainer: [CONTAINER_NAME.COLUMNS],
          toContainer: CONTAINER_NAME.ROWS
        },
        {
          fromContainer: [CONTAINER_NAME.SEPARATORS],
          toContainer: CONTAINER_NAME.SEPARATORS
        }
      ]
    },

    {
      fromStyle: GRID_STYLES.HORIZONTAL.value,
      toStyle: GRID_STYLES.VERTICAL.value,
      mappings: [
        {
          fromContainer: [CONTAINER_NAME.ROWS],
          toContainer: CONTAINER_NAME.COLUMNS
        }
      ]
    },
    {
      fromStyle: GRID_STYLES.HORIZONTAL.value,
      toStyle: GRID_STYLES.PIVOT.value,
      mappings: [
        {
          fromContainer: [CONTAINER_NAME.ROWS],
          toContainer: CONTAINER_NAME.ROWS
        },
        {
          fromContainer: [CONTAINER_NAME.SEPARATORS],
          toContainer: CONTAINER_NAME.SEPARATORS
        }
      ]
    },
    {
      fromStyle: GRID_STYLES.HORIZONTAL.value,
      toStyle: GRID_STYLES.DRILL_DOWN.value,
      mappings: [
        {
          fromContainer: [CONTAINER_NAME.ROWS],
          toContainer: CONTAINER_NAME.ROWS
        },
        {
          fromContainer: [CONTAINER_NAME.SEPARATORS],
          toContainer: CONTAINER_NAME.SEPARATORS
        }
      ]
    },

    {
      fromStyle: GRID_STYLES.PIVOT.value,
      toStyle: GRID_STYLES.VERTICAL.value,
      mappings: [
        {
          fromContainer: [CONTAINER_NAME.COLUMNS, CONTAINER_NAME.ROWS, CONTAINER_NAME.VALUES],
          toContainer: CONTAINER_NAME.COLUMNS
        }
      ]
    },
    {
      fromStyle: GRID_STYLES.PIVOT.value,
      toStyle: GRID_STYLES.HORIZONTAL.value,
      mappings: [
        {
          fromContainer: [CONTAINER_NAME.ROWS, CONTAINER_NAME.COLUMNS, CONTAINER_NAME.VALUES],
          toContainer: CONTAINER_NAME.ROWS
        }
      ]
    },
    {
      fromStyle: GRID_STYLES.PIVOT.value,
      toStyle: GRID_STYLES.DRILL_DOWN.value,
      mappings: [
        {
          fromContainer: [CONTAINER_NAME.ROWS, CONTAINER_NAME.COLUMNS, CONTAINER_NAME.VALUES],
          toContainer: CONTAINER_NAME.ROWS
        }
      ]
    },

    {
      fromStyle: GRID_STYLES.DRILL_DOWN.value,
      toStyle: GRID_STYLES.VERTICAL.value,
      mappings: [
        {
          fromContainer: [CONTAINER_NAME.ROWS, CONTAINER_NAME.VALUES],
          toContainer: CONTAINER_NAME.COLUMNS
        }
      ]
    },
    {
      fromStyle: GRID_STYLES.DRILL_DOWN.value,
      toStyle: GRID_STYLES.HORIZONTAL.value,
      mappings: [
        {
          fromContainer: [CONTAINER_NAME.ROWS, CONTAINER_NAME.VALUES],
          toContainer: CONTAINER_NAME.ROWS
        }
      ]
    },
    {
      fromStyle: GRID_STYLES.DRILL_DOWN.value,
      toStyle: GRID_STYLES.PIVOT.value,
      mappings: [
        {
          fromContainer: [CONTAINER_NAME.ROWS, CONTAINER_NAME.VALUES],
          toContainer: CONTAINER_NAME.ROWS
        }
      ]
    }
  ],
  GRID_STYLES_CONSTANT_PROPERTIES: {
    Pivot: [
      {
        key: CONTAINER_NAME.COLUMNS,
        properties: {
          addSideTotal: false,
          useExpanders: false,
          removeExtraSideTotalColumns: false,
        }
      },
      {
        key: CONTAINER_NAME.ROWS,
        properties: {
          useExpanders: false
        }
      }
    ]
  },
  MESSAGES: {
    get SEPARATOR_CONFIRM() {
      return localizer.getText('REPORT_PART_GRID_CONSTANTS_MESSAGE_SEPARATOR_CONFIRM');
    },
    get FUNCTION_INCONSISTENT() {
      return localizer.getText('REPORT_PART_GRID_CONSTANTS_MESSAGE_FUNCTION_INCONSISTENT');
    },
    get M07() {
      return localizer.getText('REPORT_PART_GRID_CONSTANTS_MESSAGE_CHANGE_FUNCTION_TYPE');
    }
  },
  DEFAULT_VALUE_PROPERTIES: {
    TABLE: {
      ALTERNATIVE_BACKGROUND: 'None',
      ALTERNATIVE_BACKGROUND_COLOR: '#EFEFEF'
    },
    COLUMNS: {
      FONT: {
        FAMILY: 'Proxima Nova',
        COLOR: '#45525c',
        SIZE: 14
      },
      WIDTH: {
        VALUE: 150,
        UNIT: 'Pixels'
      },
      WORDWRAP: false,
      ALIGNMENT: 'left',
      VERTICAL_ALIGNMENT: 'middle'
    },
    ROWS: {
      HEIGHT: 40
    },
    HEADERS: {
      FONT: {
        FAMILY: 'Proxima Nova',
        SIZE: 14,
        COLOR: '#45525c',
        BACKGROUND_COLOR: '#f6f8fa',
        BOLD: true,
        ITALIC: false,
        UNDERLINE: false
      },
      DISPLAY: 'inline-block',
      ALIGNMENT: 'left',
      VERTICAL_ALIGNMENT: 'middle',
      WORDWRAP: false
    }
  },
  MAXIMUM_FIELD: {
    PIVOT: {
      LABEL: 3,
      VALUE: 3
    }
  },
  DEFAULT_CELL_STYLE: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'pre'
  },
  EMPTY_CELL_COLOR: '#000',
  EMPTY_CELL_BACKGROUND_COLOR: '#FFF',
  MAX_LENGTH_PREVIEW_TITLE: 256,
  get TITTLE_SETTINGS_TOOLTIP() {
    return localizer.getText('REPORT_PART_GRID_CONSTANTS_LABEL_TITTLE_SETTINGS_TOOLTIP');
  },
  get DESCRIPTION_SETTING_TOOLTIP() {
    return localizer.getText('REPORT_PART_GRID_CONSTANTS_LABEL_DESCRIPTION_SETTING_TOOLTIP');
  },
  RECORDS_MAX_LENGTH: 50,
  DEFAULT_SETTING_VALUE: {
    refreshIntervalDefault: {
      enable: false,
      isAll: true,
      latestRecord: 0,
      updateInterval: 0
    },
    conditionalFormattingDefault: {
      rules: []
    },
    border: {
      top: {
        color: '#dbdcdd',
        dashStyle: 'solid',
        thinkness: 1
      },
      right: {
        color: '#dbdcdd',
        dashStyle: 'solid',
        thinkness: 1
      },
      bottom: {
        color: '#dbdcdd',
        dashStyle: 'solid',
        thinkness: 1
      },
      midVer: {
        color: '#dbdcdd',
        dashStyle: 'solid',
        thinkness: 1
      },
      left: {
        color: '#dbdcdd',
        dashStyle: 'solid',
        thinkness: 1
      },
      midHor: {
        color: '#dbdcdd',
        dashStyle: 'solid',
        thinkness: 1
      }
    }
  },
  COLLAPSE_STATUS: {
    COLLAPSE: -1,
    EXPAND: 1,
    DEFAULT: 0
  },
  DEFAULT_PIVOT_GRID_CELL_STYLE: { boxSizing: 'content-box' }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ReportPartGridConstants.js